module.exports = __webpack_public_path__ + "media/images/noticias/receta_digital-e3df972d341b0d3502dff54441e12d1b.jpg";